export default __webpack_public_path__ + "static/media/GT-Cinetype-Bold.eb0b8cc3.woff2";